import { render, staticRenderFns } from "./BulletIcon.vue?vue&type=template&id=25e0004d&"
import script from "./BulletIcon.vue?vue&type=script&lang=js&"
export * from "./BulletIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports